import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  label: "",
};

const pageLoaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.loading = action.payload.loading;
      // state.label = action.payload.label;
    },
  },
});

export const { setLoader } = pageLoaderSlice.actions;
export default pageLoaderSlice.reducer;
